<div class="job-card" data-testid="job-card" [attr.data-job-id]="job.execution.jobId">
  <div class="job-header">
    <div class="job-info">
      <h3 class="job-name" data-testid="job-card-name">{{ job.displayName }}</h3>
      <p class="job-metadata" *ngIf="job.execution.createdAt || job.execution.dt">
        {{ relativeTime }}
      </p>
      <p class="job-creator" *ngIf="showCreator && job.execution.createdByUserEmail">
        {{ job.execution.createdByUserEmail }}
      </p>
    </div>
    <div class="job-status" [style.color]="statusConfig.color">
      <lib-cdw-icon
        [icon]="statusConfig.icon"
        [class.rotating]="isRunning"
        class="status-icon"
      ></lib-cdw-icon>
      <span class="status-text" data-testid="job-card-status">{{ statusConfig.text }}</span>
    </div>
  </div>

  <!-- Progress bar for running jobs with known progress -->
  <div class="job-progress" *ngIf="isRunning && job.progress !== undefined">
    <div class="progress-info">
      <span class="progress-label">Progress</span>
      <span class="progress-percentage">{{ job.progress }}%</span>
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="job.progress"
      class="progress-bar"
    ></mat-progress-bar>
  </div>

  <!-- Indeterminate progress bar for running jobs without progress -->
  <div class="job-progress" *ngIf="isRunning && job.progress === undefined">
    <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
  </div>

  <!-- Job details (metrics like asset counts) -->
  <div class="job-details" *ngIf="jobDetails.length > 0">
    <div class="detail-item" *ngFor="let item of jobDetails">
      <span class="detail-label">{{ item.label }}:</span>
      <span class="detail-value">{{ item.value }}</span>
    </div>
  </div>

  <!-- Export download link -->
  <div class="job-export-link" *ngIf="hasExportLink">
    <a
      (click)="downloadExport()"
      class="export-link"
      data-testid="job-card-export-link"
    >
      <lib-cdw-icon icon="open_in_new" [size]="'16px'"></lib-cdw-icon>
      {{ exportLinkLabel }}
    </a>
  </div>

  <!--
    Cancel button — visible only while the job is running (canCancel === true).
    Same NgRx action as the device-search stuck-job banner; the cancelJob$
    effect handles the optimistic local lock release for grid-scoped jobs.
    For non-grid jobs (cache refresh, exports, imports) the lock release is
    a no-op and only the API call runs.
  -->
  <div class="job-cancel-action" *ngIf="canCancel">
    <button
      mat-stroked-button
      color="warn"
      type="button"
      (click)="cancelJob()"
    >
      Cancel
    </button>
  </div>
</div>
